import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ProcessList.scss";
import { useParams } from "react-router-dom";

const ProcessList = () => {
  const [data, setData] = useState(null);
  const { option2 } = useParams();

  const checklistReportDetails = async () => {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const user_id = localStorage.getItem("session_user_id");
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("task_id", option2);

    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=ProcessList&status=1`,
        formData
      )
      .then((resp) => {
        setData(resp.data);
      });
  };
  useEffect(() => {
    checklistReportDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option2]);
  return (
    <div className="checklist_report_section">
      <div className="container-fluid">
        <div className="user_detail">
          <div className="checklist_report_title">
            <h2>Process List</h2>
          </div>
        </div>
        <div className="checklist_report_inner">
          <div className="checklist_report_table">
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody dangerouslySetInnerHTML={{ __html: data }}></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessList;
